import {axiosInstance} from './axiosInstance';

export const holdBillService = {
  /**
   * Create a new hold bill
   * @param {Object} holdBillData - Hold bill data
   * @returns {Promise<Object>} Created hold bill
   */
  createHoldBill: async (holdBillData) => {
    try {
      const response = await axiosInstance.post('/api/hold-bills', holdBillData);
      return response.data;
    } catch (error) {
      console.error('Error creating hold bill:', error);
      throw error.response ? error.response.data : error;
    }
  },

  /**
   * Get all hold bills
   * @returns {Promise<Array>} List of hold bills
   */
  getAllHoldBills: async () => {
    try {
      const response = await axiosInstance.get('/api/hold-bills');
      return response.data;
    } catch (error) {
      console.error('Error fetching hold bills:', error);
      throw error.response ? error.response.data : error;
    }
  },

  /**
   * Search hold bills
   * @param {string} keyword - Search keyword
   * @returns {Promise<Array>} List of matching hold bills
   */
  searchHoldBills: async (keyword) => {
    try {
      const response = await axiosInstance.get(`/api/hold-bills/search?keyword=${encodeURIComponent(keyword)}`);
      return response.data;
    } catch (error) {
      console.error('Error searching hold bills:', error);
      throw error.response ? error.response.data : error;
    }
  },

  /**
   * Get a specific hold bill
   * @param {number} id - Hold bill ID
   * @returns {Promise<Object>} Hold bill details
   */
  getHoldBillById: async (id) => {
    try {
      const response = await axiosInstance.get(`/api/hold-bills/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching hold bill:', error);
      throw error.response ? error.response.data : error;
    }
  },

  /**
   * Delete a hold bill
   * @param {number} id - Hold bill ID
   * @returns {Promise<void>}
   */
  deleteHoldBill: async (id) => {
    try {
      const response = await axiosInstance.delete(`/api/hold-bills/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting hold bill:', error);
      throw error.response ? error.response.data : error;
    }
  },

  /**
   * Process a hold bill into a sales order
   * @param {number} id - Hold bill ID
   * @returns {Promise<Object>} Processed hold bill
   */
  processHoldBill: async (id) => {
    try {
      const response = await axiosInstance.post(`/api/hold-bills/${id}/process`);
      return response.data;
    } catch (error) {
      console.error('Error processing hold bill:', error);
      throw error.response ? error.response.data : error;
    }
  }
}; 